import React from "react";

import PSSLoginLayout from "../layouts/PSSLoginLayout";

import AccessCode from "./components/AccessCode";
import PSSMyAccount from "./components/PSSUserAccount";
import StartProtection from "./components/StartProtection";
import FraudArmor from "./components/FraudArmor";
import PssSisk from "./components/Sisk";
import Aflac from "./components/Aflac/Aflac";
import AflacRegister from "./components/Aflac/AflacRegister";
import CommerceBank from "./components/CommerceBank"
import GenericResponseLandingPage from "./components/GenericResponseLanding";

export const PssLandingRoutes = () => {
    return (
        <React.Fragment>
            <PSSLoginLayout exact path="/pss_landing/ProvisionalResponseLandingPage1" component={AccessCode} />
            <PSSLoginLayout exact path="/pss_landing/StartProtection" component={StartProtection} />
            <PSSLoginLayout exact path="/pss_landing/ProvisionalResponseLandingPage2" component={PSSMyAccount} />
            <PSSLoginLayout exact path="/pss_landing/FraudArmor" component={FraudArmor} />
            <PSSLoginLayout exact path="/pss_landing/PssSisk" component={PssSisk} />
            <PSSLoginLayout exact path="/pss_landing/Aflac" component={Aflac} />
            <PSSLoginLayout exact path="/pss_landing/AflacRegister" component={AflacRegister} />
            <PSSLoginLayout exact path="/pss_landing/CommerceBank" component={CommerceBank} />
            <PSSLoginLayout exact path="/pss_landing/GenericResponseLandingPage" component={GenericResponseLandingPage} />
        </React.Fragment>
    );
};
